import { transcribe } from "./endpoints";

export { service } from "./endpoints";
export { TranscribeBody, Transcription, transcriptionRefusals } from "./schemas";

export const contract = {
  transcriptions: { create: transcribe },
} as const;
